var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarketStrategy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H24C30.6274 0 36 5.37258 36 12V24C36 30.6274 30.6274 36 24 36H12C5.37258 36 0 30.6274 0 24V12Z",
    fill: "#EDFAF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3332 16.6666C23.3332 19.9953 19.6405 23.462 18.4005 24.5326C18.285 24.6195 18.1444 24.6665 17.9998 24.6665C17.8553 24.6665 17.7147 24.6195 17.5992 24.5326C16.3592 23.462 12.6665 19.9953 12.6665 16.6666C12.6665 15.2522 13.2284 13.8956 14.2286 12.8954C15.2288 11.8952 16.5853 11.3333 17.9998 11.3333C19.4143 11.3333 20.7709 11.8952 21.7711 12.8954C22.7713 13.8956 23.3332 15.2522 23.3332 16.6666Z",
    stroke: "#00A651",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 18.6667C19.1046 18.6667 20 17.7713 20 16.6667C20 15.5621 19.1046 14.6667 18 14.6667C16.8954 14.6667 16 15.5621 16 16.6667C16 17.7713 16.8954 18.6667 18 18.6667Z",
    stroke: "#00A651",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketStrategy);
export default __webpack_public_path__ + "static/media/marketStrategy.c6e77bcdaf2ec26b585e3700e73222f1.svg";
export { ForwardRef as ReactComponent };